import {
  AssessmentEvaluationSaga,
  AuthSaga,
  ConfigSaga,
  ExperimentsSaga,
  FirebaseSaga,
  HistogramSaga,
  IterableSaga,
  LanguageSaga,
  NotificationSaga,
  ProgressSaga,
  SentryService,
  StatsSaga,
  parseError,
} from '@web_opxp/features';
import { Lottie } from '@web_opxp/lottie';
import { Dispatch } from 'redux';
import { all, call, put, spawn } from 'redux-saga/effects';
import { NetworkError, RequestAbortedError, SharedErrors } from 'web_core_library';
import { unityEngineSaga } from 'web_unity_engine';
import { AchievementsSaga } from '../achievements';
import { AppSaga } from '../app';
import { AssessmentSaga } from '../assessment';
import { BridgeSaga } from '../bridge';
import { CyclesSaga } from '../cycles';
import dashboardWatcher from '../dashboard/saga';
import { EvaluationSaga } from '../evaluation';
import exercisePageWatcher from '../exercise/saga';
import { Saga as ExercisesPageSaga } from '../exercises';
import { FeedbackSaga } from '../feedback';
import { GroupSaga } from '../groupAdmin';
import { Saga as HighscoresSaga } from '../highscores';
import { MigrationSaga } from '../migration';
import { PersonalizationSaga } from '../personalization';
import { SessionSaga } from '../session';
import { SubscriptionSaga } from '../subscription';
import { SuccessPredictorSaga } from '../successPredictor';
import { TrainingIntensitySaga } from '../trainingIntensity';
import { UnitySaga } from '../unity';

export function* handleErrorSaga(error: Error | SharedErrors.BaseError) {
  console.error(error.message);
  const action = yield call(parseError, error);
  if (!action) {
    return;
  }
  yield put(action);
  if (error instanceof NetworkError || error instanceof RequestAbortedError) {
    // do not track known http errors
    return;
  }
  yield call(SentryService.captureException, error);
}

export default function* rootSaga(dispatch: Dispatch) {
  const sagas = [
    unityEngineSaga,
    AppSaga,
    FirebaseSaga,
    AuthSaga,
    Lottie.Saga,
    CyclesSaga,
    HistogramSaga,
    ProgressSaga,
    dashboardWatcher,
    exercisePageWatcher,
    SessionSaga,
    ConfigSaga.default,
    StatsSaga,
    UnitySaga,
    LanguageSaga,
    ExercisesPageSaga,
    HighscoresSaga,
    EvaluationSaga,
    PersonalizationSaga,
    AssessmentSaga,
    NotificationSaga,
    MigrationSaga,
    BridgeSaga,
    AchievementsSaga,
    SuccessPredictorSaga,
    FeedbackSaga,
    ExperimentsSaga,
    GroupSaga,
    SubscriptionSaga,
    AssessmentEvaluationSaga,
    IterableSaga,
    TrainingIntensitySaga.default,
  ];
  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga, dispatch);
          } catch (error) {
            yield call(handleErrorSaga, error as Error | SharedErrors.BaseError);
          }
        }
      })
    )
  );
}
